import {Route, Switch} from "react-router-dom";
import Login from "../../auth/Login";
import Register from "../../auth/Register";
import Dashboard from "../../dashboard/Dashboard";
import Profile from "../../dashboard/Profile";
import ChangePassword from "../../dashboard/ChangePassword";
import Users from "../../dashboard/Users";
import ForgotPassword from "../../auth/ForgotPassword";
import ResetPassword from "../../auth/ResetPassword";
import Walls from "../../dashboard/Walls";
import AddWall from "../../dashboard/AddWall";
import AddCeiling from "../../dashboard/AddCeiling";
import Ceilings from "../../dashboard/Ceilings";
import AddWalls from "../../dashboard/AddWalls";
import AddCeilings from "../../dashboard/AddCeilings";

export default function Navigation() {
    return (
        <Switch>
            <Route exact path="/" component={Login}/>
            <Route exact path="/auth/register" component={Register}/>
            <Route exact path="/auth/forgot-password" component={ForgotPassword}/>
            <Route exact path="/auth/reset-password" component={ResetPassword}/>
            <Route exact path="/user/dashboard" component={Dashboard}/>
            <Route exact path="/user/profile" component={Profile}/>
            <Route exact path="/user/users" component={Users}/>
            <Route exact path="/user/walls" component={Walls}/>
            <Route exact path="/user/add-wall" component={AddWall} />
            <Route exact path="/user/add-wall-select" component={AddWalls}/>
            <Route exact path="/user/ceilings" component={Ceilings}/>
            <Route exact path="/user/add-ceiling" component={AddCeiling}/>
            <Route exact path="/user/add-ceiling-select" component={AddCeilings}/>
            <Route exact path="/user/change-password" component={ChangePassword}/>
        </Switch>
    )
}
